import React, { Component } from 'react';
import Header from './Header';
import { Footer } from 'tn-components-library';
import Home from '../home';
import Dashboard from "../dashboard"
import Report from "../report"
import { Route,  Router, Switch,HashRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import PropTypes from 'prop-types';
import LoginRedirect from '../../container/login';
import UnAuth from '../../container/unauthorizedaccess';
import ResNotFound from '../../container/resourcenotfound';
import { footerUrls, getRoleDetails, isStaffingEnabled } from "../../utils";
import ConsentFrom from '../consentFrom';
import { trackingPendoId } from '../../const' 



const history = createBrowserHistory();

const AuthRoute = ({ component: Component,  ...rest }) => {
    //  Page permission
    const userDetails = {
        Tnp1XEnabled: window.customrole.UserContext.tnpenabled,
        PLAN2x: window.customrole.UserContext.tnp2xenabled,
        Tnr2xEnabled: window.customrole.UserContext.tnr2xenabled,
        CustomRoleEnabled: window.customrole.UserContext.customroleenabled,
        AdminEnabled: window.customrole.UserContext.adminenabled,
        Tnr1xEnabled: window.customrole.UserContext.tnr1xenabled,
        DataFeedEnabled: window.customrole.UserContext.DataFeedEnabled,
        personaID: window.customrole.UserContext.personaID,
        responsibilityIdsCSV: window.customrole.UserContext.responsibilityIdsCSV,
    }
    const roles = getRoleDetails(window.customrole.UserContext.geminiroles)
    const isStaffing = isStaffingEnabled(roles)
    if (checkPagePermission(rest.pageName, rest.state)) {
        
        return (<div>
            {rest.pageName !== 'Report' && <Header />}
            <Route {...rest} render={props => (<Component {...props} />)} />
            {rest.pageName !== 'Report' && <div className='custom-role-footer'><Footer roles={roles} staffing={isStaffing} plan={userDetails.PLAN2x} recruit={userDetails.Tnr2xEnabled} customRole={userDetails.CustomRoleEnabled} pageUrl={footerUrls}/></div>}
        </div>);

    } else {
        return (
            <div>
                <Header />
                <Route {...rest} render={props => (
                    <UnAuth {...props} />)} />
                <Footer roles={roles} staffing={isStaffing} plan={userDetails.PLAN2x} recruit={userDetails.Tnr2xEnabled} customRole={userDetails.CustomRoleEnabled} pageUrl={footerUrls}/>
            </div>
        );
    }
};

const checkPagePermission = (pageName, state) => {
    //Check page exists in his accessible feature     
    //Allow home by default

    return state.auth.userObject.isAuthorized;
};

class Root extends Component {

    constructor(props, context) {
        super(props, context);
        this.startPendoTracking = this.startPendoTracking.bind(this);
    }

      startPendoTracking() {
        (function(apiKey){
          (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
          v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
              y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
              z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
        })(trackingPendoId);

        setTimeout(function () {
            if(!pendo){
                return;
            }
            pendo.initialize({
                visitor: {
                    id: window.customrole.UserContext.userid,
                    role: window.customrole.UserContext.personaName,
                },
                account: {
                    id:  window.customrole.UserContext.clientname,
                }
            });
        }, 1500)
      }

    componentDidMount () {
        if( window.customrole && window.customrole.UserContext && window.customrole.UserContext.ishotjarenabled && window.customrole.UserContext.isLatestAgreementAccepted){
            this.startPendoTracking()
        }
    }

    render() {
        let state = this.context.store.getState();
        if (state.auth.userObject && state.auth.userObject.isAuthenticated) {
            return (
                <div>
                    <HashRouter>
                        <div>

                            <div>
                                <Switch>
                                    <AuthRoute pageName="Home" state={state} exact path="/" component={Home} />
                                    <AuthRoute pageName="Dashboard" state={state}  path="/dashboard" component={Dashboard} />
                                    <AuthRoute pageName="Report" state={state} path="/report" component={Report} />
                                    {/*<AuthRoute pageName="Myaccount" state={state} path="/myaccount" component={Account} />*/}
                                    <Route state={state} history={history} component={ResNotFound} />
                                </Switch>
                            </div>
                        </div>
                    </HashRouter>
                    <ConsentFrom enableHotJarTracking={this.startPendoTracking}/>
                </div>
            )
        } else {
            return (
                <div>
                    <Router history={history}>
                        <div>
                            <Route path='/' component={LoginRedirect} />
                        </div>
                    </Router>
                </div>
            )
        }

    }


}

Root.contextTypes = {
    store: PropTypes.object
}

export default Root;
